module.exports = __webpack_public_path__ + "static/media/loading.09754aa8.gif";